import { graphql } from "react-relay";

export const QUERY = graphql`
	query limitedCartDiscountsScreen_Query($numItemsPerPage: Int!) {
		...limitedCartDiscountTable_LimitedCartDiscountsFragment
			@arguments(first: $numItemsPerPage, after: null)
	}
`;
